import React, { Component } from 'react';
import '../css/components/BannerInicioPromo.css';

class BannerInicioPromo extends Component {
  render() {
    return (
      <div className="promo__div-banner items-center gap-0 md:gap-5 text-font5">
      <div className="flex-grow text-left md:text-left md:pl-0">
        <div className="promo__div-principal bg-sphericaMainDefault md:bg-sphericaSecondary">
          <img src={this.props.logo} alt='logoPromo' className='hidden md:block' width={190}/>
          <div className="md:pt-10 p-16 md:pl-0">
            <h1 className="promo__div-Titulo text-white md:text-sphericaPrimary ">{this.props.titulo}</h1>
            {this.props.descripcion && <div className="promo__div-descripcion text-white md:text-sphericaPrimary">{this.props.descripcion}</div>}
            {this.props.link && <div className="promo__div-link">{this.props.link}</div>}
          </div>
        </div>
      </div>
      </div>




    ); 
  }
}

export default BannerInicioPromo;